// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"koxIP","table":"_8zHbg","line":"pVAg1","label":"_3arvO","value":"_19Bd9","docContainer":"kShpj","dateDocument":"_3aJwG"};